import Vue from "vue";
import VueRouter from "vue-router";

import Login from "@/pages/Login.vue";
import UsersView from "@/pages/Users.vue";
import ConfigView from "@/pages/Config.vue";

import PortfolioView from "@/pages/portfolio/Index.vue";
import PortfolioStoreView from "@/pages/portfolio/store/Index.vue";
import PortfolioShowView from "@/pages/portfolio/Show.vue";

import Peoples from "@/pages/peoples/Index.vue";
import PeoplesStore from "@/pages/peoples/Store.vue";

import Orders from "@/pages/orders/Index.vue";
import OrdersStore from "@/pages/orders/store/Index.vue";

import Link from "@/pages/Link.vue";
import Links from "@/pages/links/Index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Login,
    name: "Início",
  },
  {
    path: "/login",
    component: Login,
    name: "Login",
  },
  {
    path: "/configuracoes",
    component: ConfigView,
    name: "Configurações",
    meta: { requiresAuth: true },
  },
  {
    path: "/usuarios",
    component: UsersView,
    name: "Usuários",
    meta: { requiresAuth: true },
  },
  {
    path: "/portfolio/adicionar",
    component: PortfolioStoreView,
    name: "Nova Área",
    meta: { requiresAuth: true },
  },
  {
    path: "/portfolio/:id/ver",
    component: PortfolioShowView,
    name: "Link Completo",
    meta: { requiresAuth: true },
  },
  {
    path: "/portfolio/:id",
    component: PortfolioStoreView,
    name: "Alterar Área",
    meta: { requiresAuth: true },
  },
  {
    path: "/portfolio",
    component: PortfolioView,
    name: "Portfólio",
    meta: { requiresAuth: true },
  },
  {
    path: "/links",
    component: Links,
    name: "Links",
    meta: { requiresAuth: true },
  },
  {
    path: "/pedidos",
    component: Orders,
    name: "Pedidos",
    meta: { requiresAuth: true },
  },
  {
    path: "/pedidos/adicionar",
    component: OrdersStore,
    name: "Novo Pedido",
    meta: { requiresAuth: true },
  },
  {
    path: "/pedidos/:id",
    component: OrdersStore,
    name: "Alterar Pedido",
    meta: { requiresAuth: true },
  },
  {
    path: "/pessoas/:pathMatch(.*)*",
    redirect: "/cadastro",
  },
  {
    path: "/cadastro",
    component: Peoples,
    name: "Cadastro",
    meta: { requiresAuth: true },
  },
  {
    path: "/cadastro/adicionar",
    component: PeoplesStore,
    name: "Novo Cadastro",
    meta: { requiresAuth: true },
  },
  {
    path: "/cadastro/:id",
    component: PeoplesStore,
    name: "Alterar Cadastro",
    meta: { requiresAuth: true },
  },
  {
    path: "/link/:token",
    component: Link,
    name: "Link de Compartilhamento",
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

import store from "@/store";

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((route) => route.meta.requiresAuth);

  const token = localStorage.getItem("token");
  const userRaw = localStorage.getItem("usuario");
  const permissionsRaw = localStorage.getItem("permissions");

  const isAuthenticated = !!token && !!userRaw && !!permissionsRaw;

  if (["/", "/login"].includes(to.path)) {
    if (isAuthenticated) {
      return next("/portfolio");
    }

    return next();
  }

  if (requiresAuth) {
    if (!isAuthenticated) {
      return next("/login");
    }

    if (!store.state.users.token) {
      store.commit("users/SET_TOKEN", token);
      store.commit("users/SET_USER", JSON.parse(userRaw));
      store.commit("users/SET_PERMISSIONS", JSON.parse(permissionsRaw));
    }
  }

  next();
});

export default router;
